/**
 * Shared retry-attempt count for rate-limit (429/503) backoff, independently
 * duplicated across BaseCloudProvider.fetchWithAuth, GoogleDrive's own
 * fetchWithAuth override, and S3's s3Fetch — this only unifies the attempt
 * count each already reads from; the backoff formula and control-flow
 * phrasing (`>` vs `<=`) stay as each file's own, to avoid a bigger refactor
 * than the setting itself calls for.
 */
import { getSettingValue } from "../settings/settingsStore";

export function maxRetryAttempts(): number {
  const v = getSettingValue("backend", "rateLimitRetryAttempts");
  return typeof v === "number" && v >= 0 ? v : 5;
}
